import {
  verifyOtp,
  getPatientInformation } from
"../../../services/rhapsody/ViewMrn";
import { useState, useEffect } from "react";
import { config } from "../../../utils/constants";
import { getMaskedMobileNo } from "../../../common/MaskedMobileNo";

const OtpVerificationNew = ({
  setShowModal,
  setCurrentPage,
  setPatientDetails,
  emiratesId,
  setEmiratesId,
  mobileNumber,
  id,
  translationMap
}) => {
  const [otp, setOtp] = useState({
    first: "",
    second: "",
    third: "",
    fourth: ""
  });
  const [alert, setAlert] = useState(false);
  const [error, setError] = useState("");
  const [timer, setTimer] = useState(300);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [blockTimer, setBlockTimer] = useState(0);
  const [isContinueDisabled, setIsContinueDisabled] = useState(true);
  const [, setOtpEntered] = useState(0);

  useEffect(() => {
    if (blockTimer > 0) {
      const interval = setInterval(() => {
        setBlockTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (blockTimer === 0 && isBlocked) {
      setIsBlocked(false);
    }
  }, [blockTimer, isBlocked]);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else {
      setIsResendEnabled(true);
    }
  }, [timer]);

  const handleOtpChange = (e) => {
    setError("");
    const { id, value } = e.target;
    if (/^\d?$/.test(value)) {
      setOtp((prevOtp) => {
        const updatedOtp = { ...prevOtp, [id.split("-")[1]]: value };
        const allInputsCleared = Object.values(updatedOtp).every(
          (val) => val === ""
        );
        setIsContinueDisabled(allInputsCleared);
        return updatedOtp;
      });
      if (value.length === 1 && e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
      }
    }
  };

  const handleResendCode = async () => {
    setError("");
    if (isBlocked) {
      setError(translationMap?.otpBlocked || "Your OTP has been blocked due to multiple failed attempts. Please try again after 5 minutes.");
      setIsContinueDisabled(true);
      return;
    }
    const info = await getPatientInformation(emiratesId);
    if (info) {
      setAlert(true);
      setIsResendEnabled(false);
      setTimer(300);
    }
  };

  const otpVerification = async () => {
    setAlert(false);
    setError("");
    // if (isBlocked) {
    //     setError(translationMap?.otpBlocked || "Your OTP has been blocked due to multiple failed attempts. Please try again after 5 minutes.");
    //     return;
    // }
    const fullOtp = otp.first + otp.second + otp.third + otp.fourth;
    try {
      const result = await verifyOtp(fullOtp, id, emiratesId);
      setOtp({ first: "", second: "", third: "", fourth: "" });
      if (result.data) {
        setShowModal(false);
        setPatientDetails(result.data);
        setCurrentPage("result");
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (error.response.data.error === "otpBlocked") {
          setIsBlocked(true);
          setBlockTimer(300);
          setError(
            translationMap?.otpBlocked || "Your OTP has been blocked due to multiple failed attempts. Please try again after 5 minutes."
          );
        } else if (error.response.data.error === "otpExpired") {
          setError(translationMap?.otpExpired || "OTP Expired. Please resend it again.");
        } else {
          setError(translationMap?.invalidOtp || "Invalid OTP. Please try again.");
        }
      } else {
        setError(translationMap?.unexpectedError || "Unexpected error occurred. Please try again later.");
      }
      setIsContinueDisabled(true);
      setOtpEntered((prevOtp) => prevOtp + 1);
      setOtp({ first: "", second: "", third: "", fourth: "" });
    }
  };

  const handleCloseModal = async () => {
    // setEmiratesId("");
    setShowModal(false);
    const fullOtp = otp.first + otp.second + otp.third + otp.fourth;
    await verifyOtp(fullOtp, id, emiratesId);
  };

  return (
    <>
            <div
        className="modal fade Custom_Modal_Box show"
        id="mobilenumberverification"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{ display: "block" }}>
        
                <div
          className="modal-dialog  CoveragePlan_Dialog2"
          role="document">
          
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="Title_Inner_Box">
                                <h6 className="MainTitleOne">
                                    {translationMap?.mobileNoVerification}
                                </h6>
                            </div>
                        </div>
                        {alert &&
            <div className="Alert_Main_Box">
                                <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                                    <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  onClick={() => setAlert(false)}>
                  
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17 7L7 17M7 7L17 17" stroke="#002F70" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </button>
                                    <div className="Icon_box">
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <a>
                      <span className="material-symbols-outlined">
                        check_circle
                      </span>
                                        </a>
                                    </div>
                                    <div className="alert_text">
                                        <h6>
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                            <a>{translationMap?.otpResendSuccess}</a>
                                        </h6>
                                    </div>
                                </div>
                            </div>
            }
                        <div className="modal-body">
                            <div className="Manage_Dependent_Modal_Box3">
                                <p className="para_txt">
                                    {translationMap?.otpMobileNoText}{" "}
                                    <span style={{ direction: "ltr" }}>{config?.uaeCountryCode}{" "} {getMaskedMobileNo(mobileNumber)}</span>
                                </p>
                                <div className="opt_main_box">
                                    <p>{translationMap?.verificationCode}</p>
                                    <div className="custom_row" style={{ direction: "ltr" }}>
                                        {["first", "second", "third", "fourth"].map(
                      (digit, index) =>
                      <input
                        key={digit}
                        id={`otp-${digit}`}
                        type="text"
                        min="0"
                        max="9"
                        className={`input_number_verify ${
                        error ? "errorRedAlert" : ""}`
                        }
                        placeholder="0"
                        inputmode="numeric"
                        style={{ MozAppearance: "textfield" }}
                        value={otp[digit]}
                        onChange={handleOtpChange}
                        oninput="if(this.value.length > 1) this.value = this.value.slice(0, 1);"
                        onKeyDown={(e) => {
                          if (
                          e.key === "Backspace" &&
                          !otp[digit] &&
                          index > 0)
                          {
                            document
                            .querySelectorAll(".input_number_verify")[
                            index - 1].focus();
                          }
                        }} />


                    )}
                                    </div>
                                {error &&
                  <div className="verifyContent">
                                    <p className="codeErrorAlert">{error}</p>
                                    </div>
                  }
                                    <p className="opt_timer_box">
                                        {isBlocked ?
                    blockTimer > 0 &&
                    <span className="blockTimer">{`(${Math.floor(
                        blockTimer / 60
                      )}:${String(blockTimer % 60).padStart(
                        2,
                        "0"
                      )})`}</span> :

                    timer > 0 &&
                    <span className="optTimer">{`(${Math.floor(
                        timer / 60
                      )}:${String(timer % 60).padStart(2, "0")})`}</span>
                    }
                                    </p>
                                </div>
                                <h6 className="Gray_Title">
                                    {translationMap?.notGetCode}{" "}
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a
                    onClick={() => {
                      if (!isBlocked && isResendEnabled) {
                        handleResendCode();
                      }
                    }}
                    style={{
                      cursor:
                      !isBlocked && isResendEnabled ?
                      "pointer" :
                      "not-allowed",
                      color: !isBlocked && isResendEnabled ? "#3b4f63" :
                      "gray"
                    }}>
                    
                                        {translationMap?.clickHereToResend || "Click here to resend"}.
                                    </a>
                                </h6>
                            </div>
                        </div>

                        <div className="modal-footer modal_footer_btn_box2">
                            <button
                type="button"
                className="btn bluetrans_btn_link"
                data-dismiss="modal"
                onClick={handleCloseModal}>
                
                                {translationMap?.back}
                            </button>
                            <button
                type="button"
                className={`${
                isContinueDisabled ? "disabled_btn_link" : "btn blue_btn_link"}`
                }
                disabled={isContinueDisabled}
                onClick={otpVerification}
                style={{
                  cursor: isBlocked ? "not-allowed" : "pointer"
                }}>
                
                                {" "}
                                {translationMap?.continue}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>);

};


export default OtpVerificationNew;